module.exports = __webpack_public_path__ + "static/img/naturalCircle0.c8d3636.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle0.svg
// module id = eIUq
// module chunks = 1